enum AccountStatus {
  ACCESS="ACCESS",
  BLOCKED = "BLOCKED",
  WAITING = "WAITING"
}

export default AccountStatus;